export const PLAYER_UPDATE_EVENT = 'playerUpdate'
export const PLAYER_PLAY_EVENT = 'playerPlay'
export const PLAYER_PAUSE_EVENT = 'playerPause'
export const PLAYER_EXPIRED_CREDENTIAL_EVENT = 'playerExpiredCredential'

export const ALARM = 'alarm'
export const CANCEL = 'cancel'
export const COMPLETE = 'complete'
export const ERROR = 'error'
export const PROGRESS = 'progress'
export const READY = 'ready'
export const REMOVED = 'removed'
export const SELECTED = 'selected'
export const UPDATE = 'update'
export const PLAY = 'play'
export const PAUSE = 'pause'
export const EXPIRED_CREDENTIAL = 'expired_credential'


export const PLAYER_TYPE = {
  LIVE: 'live',
  VOD: 'vod',
  ONAIRVOD: 'onairvod',
  MOVIE: 'movie',
  BASEBALL: 'baseball'
}

export const ATTR_BY_PLAYER_TYPE = {
  live: {
    id: 'channelid',
    title: 'title'
  },
  vod: {
    id: 'contentid',
    title: 'seasontitle'
  },
  onairvod: {
    id: 'contentid',
    title: 'seasontitle'
  },
  movie: {
    id: 'movieid',
    title: 'title'
  },
  baseball: {
    id: 'contentid',
    title: 'title'
  }
}
